import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogUnprocessedEntitiesPlugin from '@backstage/plugin-catalog-unprocessed-entities/alpha';
import devtoolsPlugin from '@backstage/plugin-devtools/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';
import { apiDocsModule } from './modules/apiDocs';
import { appVisualizerModule } from './modules/appVisualizer';
import { catalogModule } from './modules/catalog';
import { catalogEntityModule } from './modules/catalogEntity';
import { devToolsModule } from './modules/devtools';
import { docsModule } from './modules/docs';
import { fetchModule } from './modules/fetch';
import { homePlugin } from './modules/home';
import { navModule } from './modules/nav';
import { notificationsModule } from './modules/notifications';
import { scaffolderModule } from './modules/scaffolder';
import { searchModule } from './modules/search';
import { settingsModule } from './modules/settings';
import { signInModule } from './modules/signIn';
import { telemetryModule } from './modules/telemetry';
import { themeModule } from './modules/theme';
import { unprocessedEntitiesModule } from './modules/unprocessedEntities';
import agentStatusPlugin from '@vivicta/backstage-plugin-agent-status/alpha';
import complianceDashboardPlugin from '@vivicta/backstage-plugin-compliance-dashboard/alpha';
import applicationPortalPlugin from '@vivicta/backstage-plugin-application-portal/alpha';
import policyReviewPlugin from '@vivicta/backstage-plugin-policy-review/alpha';
import complianceChatPlugin from '@vivicta/backstage-plugin-compliance-chat/alpha';
import operationsPortalPlugin from '@vivicta/backstage-plugin-operations-portal/alpha';
import repositoryVisualizerPlugin from '@vivicta/backstage-plugin-repository-visualizer/alpha';

export default createApp({
  features: [
    catalogPlugin,
    catalogUnprocessedEntitiesPlugin,
    devtoolsPlugin,
    scaffolderPlugin,
    techdocsPlugin,
    apiDocsModule,
    appVisualizerModule,
    catalogModule,
    catalogEntityModule,
    devToolsModule,
    docsModule,
    fetchModule,
    homePlugin,
    themeModule,
    navModule,
    notificationsModule,
    scaffolderModule,
    searchModule,
    settingsModule,
    signInModule,
    telemetryModule,
    unprocessedEntitiesModule,
    applicationPortalPlugin,
    agentStatusPlugin,
    complianceDashboardPlugin,
    policyReviewPlugin,
    complianceChatPlugin,
    operationsPortalPlugin,
    repositoryVisualizerPlugin,
  ],
});
